import classNames from "classnames";

import type { JSX } from "react";

export const inputClasses = ({
  icon,
  isInvalid,
  isColorpicker,
  isReadOnly,
  hasCopyToClipboard,
  hasPrefix,
}: {
  icon?: JSX.Element;
  isInvalid?: boolean;
  isColorpicker?: boolean;
  isReadOnly?: boolean;
  hasPrefix?: boolean;
  hasCopyToClipboard?: boolean;
}): string =>
  classNames(
    "h-[2.1875rem] block w-full rounded-[0.3125rem] border-0 px-[0.46875rem] py-[0.234375rem] text-[0.9375rem] text-foreground focus:ring-2 placeholder:text-muted-foreground ring-1 ring-inset",
    icon || isColorpicker ? "pl-[2.1875rem]" : "pl-[0.46875rem]",
    hasPrefix && "rounded-l-none border-l-0",
    hasCopyToClipboard && "pr-[2.1875rem]",
    isColorpicker && "uppercase w-[8.4375rem] pr-[0.46875rem]",
    isInvalid
      ? "ring-destructive"
      : "ring ring-input focus:ring-inset focus:ring-primary",
    {
      "bg-muted": isReadOnly,
    },
  );

export const textareaClasses = ({
  icon,
  isInvalid,
  isReadOnly,
}: {
  icon?: JSX.Element;
  isInvalid?: boolean;
  isReadOnly?: boolean;
}): string =>
  classNames(
    "h-[9.375rem] block w-full rounded-[0.3125rem] border-0 px-[0.46875rem] py-[0.234375rem] text-md text-foreground focus:ring-2 placeholder:text-muted-foreground ring-1 ring-inset resize-none",

    icon ? "pl-[2.1875rem]" : "pl-[0.46875rem]",
    isInvalid
      ? "ring-destructive"
      : "ring ring-input focus:ring-inset focus:ring-primary",
    {
      "bg-muted": isReadOnly,
    },
  );

export const wrapperClasses = ({
  isCompact,
  isReversed,
}: {
  isCompact?: boolean;
  isReversed?: boolean;
}): string =>
  classNames("flex", {
    "w-full": isCompact && !isReversed,
    grow: !isReversed,
  });

export const containerClasses = ({
  isColorPicker,
  isFullWidth,
}: {
  isColorPicker?: boolean;
  isFullWidth?: boolean;
} = {}): string =>
  classNames(
    "relative rounded-[0.234375rem] flex flex-nowrap",
    isColorPicker ? "w-[120px] grow-0" : "w-full min-w-fit flex-1 ",
    isFullWidth && "w-full",
  );

export const multiTagContainerClasses = ({
  icon,
  isReadOnly,
}: {
  icon?: JSX.Element;
  isReadOnly?: boolean;
}): string =>
  classNames(
    "flex flex-wrap items-center gap-[0.3125rem] rounded-[0.3125rem] border border-input bg-card px-[0.46875rem] py-[0.3125rem] text-[0.9375rem]",
    icon ? "pl-[2.1875rem]" : "pl-[0.46875rem]",
    isReadOnly && "bg-muted",
  );

export const multiTagInputInternalClasses = (): string =>
  classNames(
    "flex-1 bg-transparent text-foreground outline-none placeholder:text-muted-foreground min-w-[100px]",
  );
